import gql from 'graphql-tag';

export const GET_PROCESS_STATS = gql`
  query ($id: ID = null){
    grabGetProcessStats(id: $id)
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/grab/fetchStats.js